import request from '@utils/request'

const networkmodeltypeApi={
    getAll:'/train/rest/network_model_type/get_all',
}
export function getList(parameter){
    return request({
        url:'/train/rest/network_model_type/get_list'+ '/' + `${parameter}`,
        method: 'get'
    })
}

export function getAll(){
    return request({
        url:networkmodeltypeApi.getAll,
        method: 'get'
    })
}